import React from "react";
import Navbar from './Components/Navbar';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import TrafficIndexCoords from './Components/TrafficIndexCoords';
import TrafficIndexZone from './Components/TrafficIndexZone';
import Reachability from './Components/Reachability';
import About from './Components/About';


const App = () => {

  return(
    <div>
      <Router>
        <Navbar/>
        <Routes>
        <Route path = "/app/" element ={<TrafficIndexCoords />} />
        <Route path = "/app/traffic-index-zone" element ={<TrafficIndexZone />} />
        <Route path = "/app/reachability" element ={<Reachability />} />
        <Route path = "/app/about" element ={<About />} />
        </Routes>
      </Router>
    </div>
  );

}

export default App;


